export const INPUT_DATA = 'INPUT_DATA';